const themeValue = state => state.themeValue
const menus = state => state.menus
const token = state => state.token
const userInfo = state => state.userInfo


export {
    themeValue,
    menus,
    token,
    userInfo
}